import { faSliders } from '@fortawesome/pro-solid-svg-icons/faSliders';
import { ColourStateSolid } from '@ukpostbox/frontend-framework';
import React from 'react';
import AccountOverview from './Pages/AccountOverview';
import AddRuleset from './Pages/Rulesets/AddRuleset';
import Rulesets from './Pages/Rulesets/Rulesets';
import { AccountRoutes } from './Routes/AccountRoutes';
import { PaymentRoutes } from './Routes/PaymentRoutes';
import { ReferralRoutes } from './Routes/ReferralRoutes';
import { SecurityRoutes } from './Routes/SecurityRoutes';
import { SiteSettingsRoutes } from './Routes/SiteSettingsRoutes';
import { YourPlanRoutes } from './Routes/YourPlanRoutes';
import { SuggestibleRouteInterface } from '../_Global/Types/RouteTypes';

const SettingsRoutes: Array<SuggestibleRouteInterface> = [
	{
		title: 'Manage User',
		path: '/manage-account',
		icon: faSliders,
		element: <AccountOverview />,
		colour: ColourStateSolid.Success,
		children: [
			...YourPlanRoutes,
			/*            ...YourDetailsRoutes, */
			...PaymentRoutes,
			...AccountRoutes,
			...SecurityRoutes,
			...SiteSettingsRoutes,
			...ReferralRoutes,
			{
				title: 'Rulesets',
				path: '/manage-account/rulesets',
				element: <Rulesets />,
			},
			{
				title: 'Add Ruleset',
				path: '/manage-account/rulesets/add',
				element: <AddRuleset />,
			},
		],
	},
];

export { SettingsRoutes };
